import * as PropTypes from "prop-types";
import {connect} from 'react-redux';
import {form, Loader} from "@mc/mc-legacy";
import {Component} from "react";
import * as React from "react";
import ListBox from "./ListBox";
import {changePosition, fixOrder} from "../utils/utils";
import {Button, Card, CardHeader} from "reactstrap";
import {withTranslation, WithTranslation} from "react-i18next";
const {Form, FormActions, FormBody} = form;

/**
 * Dialog pro změnu pořadí položek.
 */
class ZmenitPoradiModal extends Component<WithTranslation> {

    static propTypes = {
        items: PropTypes.array.isRequired, // seznam položek k řazení
        renderItem: PropTypes.func.isRequired, // funkce pro render položky
        onOrderChanged: PropTypes.func.isRequired, // funkce volaná po uložení nového pořadí, jako parametr je předána mapa {ID => nové pořadí}
    };

    componentDidMount() {
        this.setState({
            items: [...this.props.items],
            changedIds: new Map()
        });
    };

    handleChangeOrder = (index1, index2) => {
        const {items} = this.state;
        const newItems = [...items];
        changePosition(newItems, index1, index2);
        const fromIndex = Math.min(index1, index2);
        fixOrder(newItems, "poradi", fromIndex);
        const changedIds = {...this.state.changedIds};
        for (let i = fromIndex; i < newItems.length; i++) {
            changedIds[newItems[i].id] = newItems[i].poradi;
        }
        this.setState({items: newItems, changedIds: changedIds});
    };

    render() {
        const items = this.state && this.state.items;
        const {renderItem, onOrderChanged, onClose, submitting, t} = this.props;
        return items ? <Form horizontal>
            <FormBody>
                <Card>
                    <CardHeader>
                        {t('change_order_help')}
                    </CardHeader>
                    <ListBox
                        items={items}
                        sortable
                        renderItemContent={renderItem}
                        onChangeOrder={this.handleChangeOrder}
                    />
                </Card>
            </FormBody>
            <FormActions onClose={onClose} cancelButton={t('buttons.cancel')} disabled={submitting}>
                <Button color="primary" onClick={onOrderChanged.bind(this, this.state.changedIds)} disabled={submitting}>{t('save')}</Button>
            </FormActions>
        </Form> : <Loader/>
    }
}

export default connect()(withTranslation()(ZmenitPoradiModal));
